import React from 'react';

const CERT_BASE = 'https://s3-eu-west-1.amazonaws.com/images.consupedia.com/certificates';

/**
 * Core-like hover popup for parameter certificate bonus (compare / progress bars).
 */
const BonusModal = ({
  name,
  points,
  certificate,
  totalScore,
  imgFile,
  imgFiles = [],
  t = (k) => k,
  onClick,
}) => {
  const images = Array.isArray(imgFiles) && imgFiles.length > 0
    ? imgFiles
    : imgFile
      ? [imgFile]
      : [];

  return (
    <div
      className="absolute left-1/2 top-0 z-20 w-[min(100%,18rem)] -translate-x-1/2 -translate-y-1/2 rounded-[10px] bg-white px-5 pb-2.5 pt-5 shadow-[0_5px_15px_rgba(0,0,0,0.3)]"
      onClick={onClick}
      onMouseDown={(e) => e.stopPropagation()}
      role="dialog"
      aria-label={t('Bonuspoäng')}
    >
      <h3 className="mb-0 text-center text-base font-semibold text-gray-900">
        {t('Bonuspoäng')}
      </h3>
      <ul className="my-3 list-none rounded-sm bg-[#c7deb4] px-2.5 py-0 text-sm text-gray-800">
        <li className="py-2.5">
          {certificate ? (
            <>
              {t('Produkten har fått')} <strong>{points}</strong>{' '}
              {t('bonuspoäng från certifikat för parametern')} <strong>{name}</strong>.
              {' '}
              {t('Totalt')} <strong>{totalScore}</strong>{' '}
              {t('inkluderat bonuspoängen.')}
            </>
          ) : (
            <>
              <strong>{points}</strong> {t('bonuspoäng för parametern')} <strong>{name}</strong>.
              {' '}
              {t('Totalt')} <strong>{totalScore}</strong>{' '}
              {t('inkluderat bonuspoängen.')}
            </>
          )}
        </li>
      </ul>
      <hr className="mb-2.5 mt-0 border-gray-200" />
      {images.length > 0 && (
        <div className="flex w-full flex-wrap items-center justify-center gap-2 pb-1">
          {images.map((file) => (
            <img
              key={file}
              src={`${CERT_BASE}/${file}`}
              alt={certificate || t('Certifikat')}
              className="object-contain"
              style={{ width: images.length > 1 ? '16%' : '28%', minWidth: 40 }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BonusModal;
